module.exports = __webpack_public_path__ + "static/media/img_finish.58ba71ff.svg";